module.exports = __webpack_public_path__ + "img/ct_bru-plan.253f1cb3.png";